import { Alert } from '@@/Alert';
import { Button } from '@@/buttons';
import { Link } from '@@/Link';

/**
 * CatalogAlert explains that the add-on catalog could not be refreshed: either a
 * cached catalog that may be out of date, or no catalog at all.
 */
export function CatalogAlert({
  catalogError,
  catalogLoaded,
  isRetrying,
  onRetry,
}: {
  catalogError: string;
  catalogLoaded: boolean;
  isRetrying: boolean;
  onRetry: () => void;
}) {
  return (
    <div className="row mt-4">
      <div className="col-sm-12">
        <Alert
          color="warn"
          title={
            catalogLoaded
              ? 'Showing a cached add-on catalog'
              : 'Unable to load the add-on catalog'
          }
        >
          <div className="flex flex-col items-start gap-2">
            <p className="mb-0">{catalogError}</p>
            {!catalogLoaded && (
              <p className="mb-0">
                Installed add-ons keep running and can still be opened, but no
                add-on can be installed or upgraded until the catalog loads.
                Check that Portainer can reach the catalog source, or set a
                different URL in{' '}
                <Link
                  to="portainer.settings"
                  params={{ section: 'addons-settings' }}
                  data-cy="addons-settings-link"
                >
                  add-on settings
                </Link>
                .
              </p>
            )}
            <RetryButton isRetrying={isRetrying} onRetry={onRetry} />
          </div>
        </Alert>
      </div>
    </div>
  );
}

function RetryButton({
  isRetrying,
  onRetry,
}: {
  isRetrying: boolean;
  onRetry: () => void;
}) {
  return (
    <Button
      color="default"
      size="small"
      disabled={isRetrying}
      onClick={onRetry}
      data-cy="addons-retry-catalog"
    >
      Retry
    </Button>
  );
}
